var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"sidebar__nav",attrs:{"aria-label":"Sidebar navigation"}},[_c(_setup.SidebarItemGroup,{attrs:{"items":_vm.items,"active":_setup.props.active,"is-collapsed":_setup.props.isCollapsed,"level":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }